export type CookieConsentPreferences = {
  version: number;
  essential: true;
  analytics: boolean;
  support: boolean;
  updatedAt: string;
};

const COOKIE_CONSENT_VERSION = 1;
const COOKIE_CONSENT_STORAGE_KEY = "afiis_cookie_consent_v1";
export const COOKIE_CONSENT_UPDATED_EVENT = "afiis-cookie-consent-updated";

export function getCookieConsent(): CookieConsentPreferences | null {
  if (typeof window === "undefined") {
    return null;
  }

  const value = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
  if (!value) {
    return null;
  }

  try {
    const parsed = JSON.parse(value) as CookieConsentPreferences;
    if (parsed.version !== COOKIE_CONSENT_VERSION) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
}

export function saveCookieConsent(
  values: Pick<CookieConsentPreferences, "analytics" | "support">,
) {
  if (typeof window === "undefined") {
    return;
  }

  const preferences: CookieConsentPreferences = {
    version: COOKIE_CONSENT_VERSION,
    essential: true,
    analytics: values.analytics,
    support: values.support,
    updatedAt: new Date().toISOString(),
  };

  window.localStorage.setItem(
    COOKIE_CONSENT_STORAGE_KEY,
    JSON.stringify(preferences),
  );
  window.dispatchEvent(new Event(COOKIE_CONSENT_UPDATED_EVENT));
}
